import React from 'react'

const Footer = () => {
    return (
        <footer className="site-footer">
            <div style={{
                marginBottom: "30px"
            }} className="content-container">
                <div className="">
                    <address>
                        <h1 style={{
                            marginLeft: '0px'
                        }}><>HindaTech</></h1>
                        <p>Bayan salima Bread, Fedral-Lowcost </p>
                        <p>Bauchi, Bauchi State</p>
                        <p>Email: Hindatech01@gmail.com</p>
                    </address>
                </div>

            </div>
            <hr />
            <div className="row">
                <div className="copy-rights">
                    <p>&copy; 2023 Hinda Tech. All rights reserved.</p>
                </div>
            </div>
        </footer >
    )
}

export default Footer